import type React from 'react';

import * as styles from './action-items-states.css';

export const ActionItemsLoading: React.FC = () => {
  return (
    <div className={styles.actionItemsLoading}>
      <div className={styles.actionItemsLoadingText}>
        <span>Loading action items...</span>
      </div>
    </div>
  );
};
